import { RoundFlag } from "./RoundFlag";

export function NOFlag() {
  return (
    <RoundFlag code="no">
      <rect width="20" height="20" fill="#BA0C2F" />
      <rect x="5" width="5" height="20" fill="white" />
      <rect y="7.5" width="20" height="5" fill="white" />
      <rect x="6" width="3" height="20" fill="#00205B" />
      <rect y="8.5" width="20" height="3" fill="#00205B" />
    </RoundFlag>
  );
}
